import constants from '../../constants';

const { NAMESPACE: GLOBAL_NAMESPACE } = constants;

const NAMESPACE = `${GLOBAL_NAMESPACE}/group` as const;

const FILTER_OS_VALUE_ALL = 'all' as const;

const FETCH_GROUPS_URL_PARAMS = {
  KIND: 'kind',
  SEARCH_QUERY: 'q',
} as const;

const FETCH_GROUPS_SEARCH_DEBOUNCE_THRESHOLD_MS = 300 as const;

const DELETE_GROUP_MODAL_IDENTIFIER = `${NAMESPACE}/deleteGroupModal` as const;

export default {
  DELETE_GROUP_MODAL_IDENTIFIER,
  FETCH_GROUPS_SEARCH_DEBOUNCE_THRESHOLD_MS,
  FETCH_GROUPS_URL_PARAMS,
  FILTER_OS_VALUE_ALL,
  NAMESPACE,
};
